//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import wx from 'weixin-js-sdk'

export default {
    components: {
        wx
    },
    data() {
        return {
            subStatus: true,
            popUp: false,
            orderShow: false,
            clotheShow: false,
            colorShow: false,
            flawShow: false,
            bagCode:'',
            type:0,
            name:'',
            phone:'',
            froms:[
                {
                    code:'',
                    clothe_id:0,
                    color_id:0,
                    flaw_id:[],
                    clothe:'选择附件',
                    flaw:'选择瑕疵',
                    color:'选择颜色',
                    filePath: [],
                    pics:[],
                }
            ],
            clotheIndex:0,
            colorIndex:0,
            flawIndex:0,
            picIndex:0,
            clothes: [],
            colors: [],
            flaws: [],
        }
    },
    created() {
        this.type = Number(this.$route.params.type);
        this.getAnnex();
        this.config();
    },
   
    methods: {
        addModules(){
            this.froms.push({
                    code:'',
                    clothe_id:0,
                    color_id:0,
                    flaw_id:[],
                    clothe:'选择附件',
                    flaw:'选择瑕疵',
                    color:'选择颜色',
                    filePath: [],
                    pics:[],
                });
        },
        removeModules(index){
            this.froms.splice(index, 1);
        },
        scanQRCode(key,index){
            let that = this;
            wx.ready(()=> {
                wx.scanQRCode({
                needResult: 1,
                scanType: ['barCode'],
                success: function (res) {
                    setTimeout(()=>{
                       if(key > 0){
                            that.froms[index].code = that.$func.parseScanResult(res.resultStr);
                       }else{
                            that.bagCode = that.$func.parseScanResult(res.resultStr);
                       } 
                    },300);
                }
                })
            });
            wx.error((res)=> {
                console.log(res)
                // alert(res.errMsg);
            })
        },  
        getAnnex() {
            this.$api.getAnnex({}).then((res)=>{
                if(res){
                    this.clothes = res.data.goods;
                    this.colors = res.data.colors;
                    this.flaws = res.data.flaw;
                    if(this.type <= 1){
                        this.order = res.data.order;
                        this.popUp = true;
                        this.orderShow = true;
                    }
                   
                    console.log(res);
                }
            })  
        },
        openClotheShow(index){
            this.clotheIndex = index;
            this.popUp = true;
            this.clotheShow = true;
        },
        openClotheColor(index){
            this.colorIndex = index;
            this.popUp = true;
            this.colorShow = true;
        },
        openClotheFlaw(index){
            this.flawIndex = index;
            this.popUp = true;
            this.flawShow = true;
        },
        closePop(){
            this.popUp = false;
            this.orderShow = false;
            this.clotheShow = false;
            this.colorShow = false;
            this.flawShow = false;
            this.clotheIndex = 0;
            this.colorIndex = 0;
            this.flawIndex = 0;
        },
        clotheSelect(id,title){
            this.froms[this.clotheIndex].clothe_id = id;
            this.froms[this.clotheIndex].clothe = title;
            this.closePop();
        },
        colorSelect(id,title){
            this.froms[this.colorIndex].color_id = id;
            this.froms[this.colorIndex].color = title;
            this.closePop();
        },
        flawSelect(i,title){
            let flawId = this.froms[this.flawIndex].flaw_id;
            if(flawId){
                if(flawId.indexOf(i) > -1){
                    flawId.splice(flawId.indexOf(i),1);
                    this.froms[this.flawIndex].flaw_id = flawId;
                }else{
                    this.froms[this.flawIndex].flaw_id.push(i);
                }
            }else{
                this.froms[this.flawIndex].flaw_id.push(i);
            }
            let flaw = this.froms[this.flawIndex].flaw_id;
            this.froms[this.flawIndex].flaw = '';
            flaw.forEach((item,index)=>{
                this.froms[this.flawIndex].flaw += (index == flaw.length-1 ? this.flaws[item].title : this.flaws[item].title+',');
            });
            if(this.froms[this.flawIndex].flaw_id.length < 1){
                this.froms[this.flawIndex].flaw = '选择瑕疵';
            }
        },
        submit() {
            if(!this.subStatus){
                return false;
            }
            console.log(this.froms);
            this.$api.submitAnnex({code:this.bagCode,record_type:this.type,clothe:JSON.stringify(this.froms)}).then((res)=>{
                if(res){
                    this.$func.showToast('提交成功');
                    this.subStatus = true;
                    setTimeout(()=>{
                        window.location.reload();
                    },300);
                }
            })  
        },
        config(){
             let url = (window.location.href).split('#');
            if(url[0].indexOf('?') != '-1'){
                url = url[0].split('?');
            }
            this.$api.wxSign({url:url[0]}).then((res)=>{
                if(res){
                    wx.config({
                        debug: false, 
                        appId: res.data.appId,
                        timestamp: res.data.timestamp,
                        nonceStr: res.data.nonceStr,
                        signature:res.data.signature,
                        jsApiList: [
                            "chooseImage",
                            "uploadImage",
                            "scanQRCode"
                        ]
                    });
                }
            })
        },
        uploadFile(index){
            let that = this;
            this.picIndex = index;
            wx.chooseImage({
                count: 9,
                sizeType: ['original', 'compressed'], 
                sourceType: ['album', 'camera'], 
                success: function (res) {
                    that.uploadImg(res.localIds);
                }
            });
        },
        uploadImg(localIds){
            let that = this;
            let localId = localIds.pop();
            wx.uploadImage({
                localId: localId, 
                success: function (res) {
                    let path = 'record';
                    that.$api.uploadsImgOss({serverId:res.serverId,path:path}).then((res)=>{
                        if(res){
                            that.froms[that.picIndex].filePath.push(res.data.pathName);
                            that.froms[that.picIndex].pics.push(res.data.saveName);
                            if(localIds.length > 0){
                                that.uploadImg(localIds);
                            }
                        }
                    })
                }
            });
        },
        showPic(i,index) {
            wx.previewImage({
                current: this.froms[i].filePath[index],
                urls: [this.froms[i].filePath[index]] 
            });
        },
        delImg(i,index){
            this.froms[i].filePath.splice(index,1);
            this.froms[i].pics.splice(index,1);
        },
       
    }
}



// WEBPACK FOOTER //
// ./src/pages/annex.vue